import { useRef } from "react";

import { useEffect, useState } from "react";

type Props = {
  children: React.ReactNode | ((props: { height: number }) => React.ReactNode);
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const AutoHeight = ({ children, className }: Props) => {
  const _ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const node = _ref.current;

    if (!node) return;

    const resizeObserver = new ResizeObserver(([e]) => {
      const _height = e.contentRect.height;
      setHeight(_height);
    });

    resizeObserver.observe(node);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={_ref} className={className}>
      {typeof children === "function" ? children({ height }) : children}
    </div>
  );
};
